module.exports = __webpack_public_path__ + "static/media/person-duotone.43ec80b7.svg";